<template>
	<div>
		<p class="title">点击排行</p>
		<ul class="list">
			<li v-for="(item,index) in data" :key="index">
				<router-link :to="{path:'/detail',query:{type:item.type,id:item.id}}">
					<div class="li_div">
						<div class="div_left">
							<img :src="item.title_pic" alt="">
						</div>
						<div class="div_right">
							<p :title="item.title">{{item.title}}</p>
							<div>
								<span>{{item.create_date|dateTrans}}</span>
								<span>{{item.reads}}次浏览</span>
							</div>
						</div>
					</div>
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		props:{
			data:{
				required:false,
				type:Array
			}
		}
	}
</script>

<style scoped>
	.title {
		padding: 11px 15px 10px;
		border-bottom: 1px solid #eaeaea;
		background-color: #fbfbfb;
		font-weight: 400;
		font-size: 18px;
		line-height: 20px;
		color: #555;
		border-radius: 5px 5px 0 0;
	}

	.list li {
		margin-bottom: 1px;
	}

	.list li a {
		display: block;
		background-color: #FFFFFF;
		padding: 10px 15px;
		box-sizing: border-box;
	}

	.list li a:hover {
		background-color: #fafff8;
	}

	.list li a:hover .div_right p {
		color: #4eae30;
	}

	.li_div {
		overflow: hidden;
	}

	.div_left {
		float: left;
		width: 30%;
		height: 80px;
	}

	.div_left img {
		width: 100%;
		height: 100%;
		border-radius: 5px;
	}

	.div_right {
		float: left;
		width: 70%;
		height: 80px;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.div_right p {
		overflow: hidden;
		font-size: 14px;
		color: #555;
		line-height: 20px;
		font-size: 14px;
		margin-bottom: 10px;
		height: 40px;
	}

	.div_right div {
		color: #999;
		font-size: 12px;
	}

	.div_right div span {
		margin-right: 20px;
	}
</style>
